export const marketsKeys = {
  ALL_MARKETS: 'All' as const,
  FAVORITE_MARKETS: 'Fav' as const,
};
